import { createContext, useContext } from "react";
import { BRAND_COLORS, MYCELIAL } from "./colors.js";

export const THEMES = {
  dark: {
    mode: "dark",
    bg: BRAND_COLORS.dark,
    bgAlt: "rgba(255,255,255,0.015)",
    surface: "rgba(255,255,255,0.02)",
    surfaceHover: "rgba(255,255,255,0.04)",
    border: "rgba(255,255,255,0.06)",
    borderSubtle: "rgba(255,255,255,0.04)",
    borderStrong: "rgba(255,255,255,0.08)",
    text: "#fff",
    textHigh: "rgba(255,255,255,0.85)",
    textMid: "rgba(255,255,255,0.62)",
    textLow: "rgba(255,255,255,0.50)",
    textFaint: "rgba(255,255,255,0.35)",
    textGhost: "rgba(255,255,255,0.06)",
    navBg: "rgba(10,10,15,0.92)",
    navBgClear: "transparent",
    overlayBg: "rgba(5,5,8,0.85)",
    cardBg: "rgba(255,255,255,0.01)",
    shadow: "rgba(0,0,0,0.3)",
    shadowStrong: "rgba(0,0,0,0.5)",
    particleColor: "#fff",
    selectionBg: BRAND_COLORS.purple,
    selectionText: "#fff",
    sliderTrack: "rgba(255,255,255,0.06)",
    sliderBorder: "#0A0A0F",
    tooltipBg: "#141416",
    marqueeGrad: BRAND_COLORS.dark,
    red: BRAND_COLORS.red,
    orange: BRAND_COLORS.orange,
    blue: BRAND_COLORS.blue,
    green: BRAND_COLORS.green,
    purple: BRAND_COLORS.purple,
    cyan: BRAND_COLORS.cyan,
    sporeGold: MYCELIAL.sporeGold,
    tipGreen: MYCELIAL.tipGreen,
    fruitingCoral: MYCELIAL.fruitingCoral,
  },
  light: {
    mode: "light",
    bg: "#F5F3EE",
    bgAlt: "#EBE8E2",
    surface: "rgba(0,0,0,0.025)",
    surfaceHover: "rgba(0,0,0,0.05)",
    border: "rgba(0,0,0,0.08)",
    borderSubtle: "rgba(0,0,0,0.05)",
    borderStrong: "rgba(0,0,0,0.12)",
    text: "#1A1A1F",
    textHigh: "rgba(0,0,0,0.88)",
    textMid: "rgba(0,0,0,0.72)",
    textLow: "rgba(0,0,0,0.62)",
    textFaint: "rgba(0,0,0,0.55)",
    textGhost: "rgba(0,0,0,0.10)",
    navBg: "rgba(245,243,238,0.92)",
    navBgClear: "transparent",
    overlayBg: "rgba(245,243,238,0.9)",
    cardBg: "rgba(0,0,0,0.02)",
    shadow: "rgba(0,0,0,0.08)",
    shadowStrong: "rgba(0,0,0,0.15)",
    particleColor: BRAND_COLORS.purple,
    selectionBg: BRAND_COLORS.purple,
    selectionText: "#fff",
    sliderTrack: "rgba(0,0,0,0.08)",
    sliderBorder: "#F5F3EE",
    tooltipBg: "#FFFFFF",
    marqueeGrad: "#F5F3EE",
    red: "#D42020",
    orange: "#B06828",
    blue: "#1E6BC0",
    green: "#5E6A0E",
    purple: "#5F4ED0",
    cyan: "#007D6A",
    // MYCELIAL accent colors darkened for light bg WCAG compliance
    sporeGold: "#8A7040",
    tipGreen: "#4A6340",
    fruitingCoral: "#8A5040",
  },
};

export const ThemeContext = createContext(THEMES.dark);
export const useTheme = () => useContext(ThemeContext);
